"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M18.218 7.492a1.036 1.036 0 1 1-2.072 0 1.036 1.036 0 0 1 2.072 0Zm0 3.105a1.036 1.036 0 1 1-2.072 0 1.036 1.036 0 0 1 2.072 0ZM8.904 7.492c0-.572.464-1.036 1.036-1.036h4.145a1.036 1.036 0 1 1 0 2.072H9.94a1.036 1.036 0 0 1-1.036-1.036Zm0 3.105c0-.572.464-1.036 1.036-1.036h4.145a1.036 1.036 0 0 1 0 2.072H9.94a1.036 1.036 0 0 1-1.036-1.036Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M6.82 2c-.572 0-1.035.464-1.035 1.036v12.739h-1.73c-.763 0-1.382.618-1.382 1.381v2.788c0 1.131.937 2.048 2.068 2.048.002 0 .004.002.004.004s.002.004.004.004h14.506a2.072 2.072 0 0 0 2.072-2.072V3.036c0-.572-.464-1.036-1.036-1.036H6.82Zm12.435 2.454H7.856v11.32h8.292c.572 0 1.036.464 1.036 1.037v2.082a1.035 1.035 0 1 0 2.07 0V4.453Zm-4.142 13.392v2.082H5.78a1.036 1.036 0 0 1-1.036-1.036v-1.046h10.367Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};